import Vue from 'vue';
import store from '@/store/index';
import util from '@/common/util';

// 所有的弹窗列表
// var pops = [];
// 当前弹框实例
var currentPops = [];

// const PopupManager = {
//     zIndex: 2000,
//     nextZIndex: function () {
//         return PopupManager.zIndex++;
//     }
// }

function restorePop() {
    var cur = popMgr.getCurrent();
    if (cur && cur.needRestore && !cur._isDestroyed) {
        cur.display(true);
    }
}

var popMixin = {
    store,
    data: function () {
        // 多套一层rootData的目的在于孙子组件需要监听popShow的响应
        return {
            rootData: {
                popShow: false
            }
        };
    },
    provide: function () {
        var _this = this;
        return {
            rootData: this.rootData,
            // pop组件关闭时调用
            afterLeaveCb: function () {
                if (_this._destroyFlag) {
                    // 如果设置了_destroyFlag, 就销毁组件
                    document.body.removeChild(_this.$el);
                    _this.$destroy();
                    restorePop();
                }
            },
            display: this.display,
            destroy: this.destroy
        };
    },
    methods: {
        // 打开/关闭的控制
        display(popShow, needRestore, needScrollTop) {
            // needRestore表示当前窗口的上层窗口关闭时, 当前窗口需不需要还原成打开状态
            this.needRestore = needRestore;
            this.rootData.popShow = popShow;
            this.$emit('displayChange', popShow);
            if (popShow) {
                this.ignoreScroll =
                    document.body.classList.contains('overflow-hidden');
                if (needScrollTop) {
                    this.popTop = window.scrollY;
                    window.scrollTo(0, 0);
                    util.enableScroll(false);
                }
            } else if (!this.ignoreScroll) {
                util.enableScroll(true);
            }

            if (!popShow && this.popTop !== undefined) {
                window.scrollTo(0, this.popTop);
                this.popTop = 0;
            }
        },
        // 弹窗组件销毁(showAnimation表示先放关闭动画,再销毁)
        destroy: function (showAnimation = true) {
            if (!this._isDestroyed) {
                this.$emit('beforeDestroy', this);
                if (showAnimation) {
                    this._destroyFlag = true;
                    this.display(false);
                } else {
                    document.body.removeChild(this.$el);
                    this.$destroy();
                    restorePop();
                }
                var index = currentPops.indexOf(this);
                if (index !== -1) {
                    currentPops.splice(index, 1);
                }

                if (popMgr.getVisibleLength() === 0 && !this.ignoreScroll) {
                    util.enableScroll(true);
                }
            }
        }
    }
};
const popMgr = {
    currentPops: currentPops,
    /**
     * 给弹窗注入mixin
     */
    setMixin(popVue, popMixin) {
        if (popVue.mixins) {
            popVue.mixins.push(popMixin);
        } else {
            popVue.mixins = [popMixin];
        }
    },
    /**
     * 手动创建弹框实例(和pop组件配套使用)
     * @param popVue 弹框配置, 通常可以传引用的vue弹窗配置文件, 注意:这个配置必须引用了pop组件
     * @param args 弹框实例初始化需要的参数, 可以传入propsData(代替之前手动调用init的方式)
     * @param action 弹起这个框的时候的策略, 默认closeOtherPop | hideOtherPop | normal 中的一个, 分别表示1.弹窗时关掉其他弹窗 2.隐藏其他弹窗(本窗关闭时恢复) 3.在其他弹框只上再弹新的框
     * @param needScrollTop 是否需要滚动到顶部, 关掉再还原scrollY, 默认"是"
     * @return 返回弹窗实例
     */
    create: function (
        popVue,
        args,
        action = 'closeOtherPop',
        needScrollTop = true,
        autoOpen = true
    ) {
        if (action === 'closeOtherPop') {
            this.closeAllPopWin(true);
        } else if (action === 'hideOtherPop') {
            var cur = this.getCurrent();
            if (cur) {
                cur.display(false, true);
            }
        }

        this.setMixin(popVue, popMixin);
        var pop = Vue.extend(popVue);
        var ins = new pop({
            propsData: args
        });
        ins.$mount();
        // ins.$el.style.position = 'relative';
        document && document.body.appendChild(ins.$el);
        // pops.push(ins);
        // 记录弹窗策略
        ins.action = action;

        // 自动打开
        if (autoOpen) {
            ins.display(true, false, needScrollTop);
        }
        currentPops.push(ins);
        return ins;
    },
    /**
     * 获取当前弹窗
     */
    getCurrent: function () {
        if (currentPops.length) {
            return currentPops[currentPops.length - 1];
        }
    },
    /**
     * 获取可见弹框的数量
     */
    getVisibleLength: function () {
        return currentPops.filter(ins => ins.rootData.popShow).length;
    },
    /**
     * 关掉所有打开状态的弹窗
     */
    closeAllPopWin: function (exceptHiddenPop) {
        for (var i = 0; i < currentPops.length; i++) {
            if (!exceptHiddenPop || currentPops[i].rootData.popShow) {
                currentPops[i].destroy();
                currentPops.splice(i, 1);
                i--;
            }
        }
    }
};

window.popMgr = popMgr;
export default popMgr;
